import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from "rxjs/operators";
import * as fromRegionGql from "./region.graphql";
import {RegionActions} from "./region.actions";
import {GraphqlService} from "../../../../../services/graphql.service";
import {BaseResponse} from "../../../../../common/interfaces/global-interfaces";
import {Region} from "./region.model";


@Injectable()
export class RegionEffects {

  loadData$ = createEffect(() => this.actions$.pipe(
    ofType(RegionActions.getAllRegions),
    switchMap((action) => this.apollo.queryObservable({
        query: fromRegionGql.ALL_REGIONS,
      })
    ),
    switchMap((response: any) => {
      const result: BaseResponse<Region[]> = Object.values(Object.values(response)[0])[0];
      if (result?.response?.status) {
        return [
          RegionActions.loadRegions({regions: result?.data || []}),
          RegionActions.regionsLoadingState({loading: false})
        ]
      } else {
        return [RegionActions.regionsLoadingState({loading: false})]
      }
    })
  ));

  constructor(
    private actions$: Actions,
    private apollo: GraphqlService,
  ) {
  }

}
